export default "__VITE_ASSET__553e0733__"